import React, { useState, useEffect } from "react";
import { Dialog, DialogActions, DialogContent, Button, Typography } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { SitePhotoDto } from "../../../../../../../dtos/sitePhoto";

const useStyles = makeStyles((theme: Theme) => ({
    fullScreenImage: {
        maxWidth: "100%",
        maxHeight: "calc(100vh - 200px)",
        width: "100%",
        height: "auto",
        objectFit: "contain",
        display: "block",
        margin: "0 auto",
    },
    loadingContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "400px",
        color: "#999",
    },
    dialogContent: {
        padding: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 0,
        maxHeight: "calc(100vh - 240px)",
        overflowY: "auto",
        overflowX: "hidden",
    }
}));

interface FullScreenDialogProps {
    open: boolean;
    photo: SitePhotoDto | null;
    photoUrl?: string;
    onClose: () => void;
}

export const FullScreenDialog: React.FC<FullScreenDialogProps> = ({
    open,
    photo,
    photoUrl,
    onClose
}) => {
    const classes = useStyles();
    const [imageError, setImageError] = useState(false);

    const handleImageError = () => {
        setImageError(true);
    };

    useEffect(() => {
        setImageError(false);
    }, [photoUrl]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{ style: { overflowX: "hidden", maxHeight: "calc(100vh - 96px)" } }}
            scroll="paper"
        >
            {photo ? (
                <>
                    <DialogContent className={classes.dialogContent}>
                        {photoUrl && !imageError ? (
                            <img
                                src={photoUrl}
                                alt={photo.description || photo.fileName}
                                className={classes.fullScreenImage}
                                onError={handleImageError}
                            />
                        ) : (
                            <div className={classes.loadingContainer}>
                                {imageError ? "Failed to load image" : "Loading image..."}
                            </div>
                        )}
                    </DialogContent>
                    <DialogContent style={{ overflowX: "hidden", padding: "16px 40px 0 40px", boxSizing: "border-box" }}>
                        <Typography
                            variant="body2"
                            style={{
                                textAlign: "left",
                                wordBreak: "break-word",
                                overflowWrap: "anywhere",
                                whiteSpace: "pre-line",
                                margin: 0,
                                maxWidth: "100%"
                            }}
                        >
                            {photo.description || photo.fileName}
                        </Typography>
                    </DialogContent>
                    <DialogActions style={{ justifyContent: "flex-end", padding: "16px 40px 16px 40px" }}>
                        <Button onClick={onClose}>Close</Button>
                    </DialogActions>
                </>
            ) : (
                <DialogContent>
                    <div className={classes.loadingContainer}>
                        Loading...
                    </div>
                </DialogContent>
            )}
        </Dialog>
    );
}; 